import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Button, Spinner, Paper } from 'components'

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    margin: 0,
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
`

const LoadingContainer = styled.div`
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 0.5rem;
`

const ShowMoreButton = props => {
    const {
        text,
        loadingText,
        onSelect,
        styles,
        n
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const [showLoader, setLoader] = React.useState(false)

    useEffect(() => {
        console.log('ShowMoreButton useEffect')
        setLoader(false)
    }, [n])

    const onSelectHandler = () => {
        setLoader(true)
        setTimeout(() => {
            onSelect && onSelect()
        }, 500)
    }
    const loadingButton = <LoadingContainer styles={updatedStyle}>
                            <Spinner/>
                            {loadingText || 'Getting data...'}
                        </LoadingContainer>
    return (
        <Paper>
            <Container>
                {showLoader ? <Button text={loadingButton} onSelect={() => {}} styles={updatedStyle}/>
                            : <Button text={text} onSelect={onSelectHandler} styles={updatedStyle}/>}
            </Container>
        </Paper>
    )
}

export default ShowMoreButton